import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { BookingInfoBaseComponent } from '@luggagehero/features/bookings';
import { SharedGoogleMapsService } from '@luggagehero/shared/services/google-maps';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-booking-info',
  templateUrl: './booking-info.component.html',
  styleUrls: ['./booking-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingInfoComponent extends BookingInfoBaseComponent {
  constructor(gms: SharedGoogleMapsService, translate: TranslateService, cd: ChangeDetectorRef) {
    super(gms, translate, cd);
  }
}
